import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const cn = {
	message: {
    // 基础
    'config': '设置',
    'history': '历史',
    'creator': '创建人',
    'info': '信息',
    'beginTime': '开始时间',
    'endTime': '结束时间',

		'loginTitle': '欢迎登录',
		'titleEnd': '惠尔丰后台',
		'login': '登录',
		'passwordLogin': '密码',
		'usernameLogin': '用户名',
		'verification': '验证码',
		'rememberPassword': '记住密码',
		'forgetPassword': '忘记密码?',
		'English': 'English',
		'Chinese': '中文',
		'menuSubtitle': 'APP Veristore',
		'changePassword': '修改密码',
		'usernameChange': '用户名',
		'currentPassword': '原始密码',
		'newPassword': '新的密码',
    'content': '包含7-15位,数字以及字母大小写',
		'confirmPassword': '确认密码',
		'submit': '提交',
		'back': '返回',
		'quit': '退出登录',
		'add': '新增',
		'edit': '编辑',
		'delete': '删除',
		'cancel': '取消',
		'upload': '导入',
		'import': '导入',
		'warning': '提示',
		'callTitle': '请拨打:',
		'warn': '警告',
		'modifyPassword': '修改密码',
		'logoutTip': '退出登录',
    'selectTip':'运营商展示',
		//dashboard
		'dashboard': '仪表盘',
		'totalTerminal': '总设备数',
		'activeTerminal': '总活跃设备数',
		'totalApp': '总应用数量',
		'totalAppDownload': 'APP总下载量',
		'downloadUper': '进行中的下载任务',
		'todayAppDownload': '今日App下载量',
		'downloadStatistics': '下载统计',
		'notDownload': '待下载',
		'downloaded': '已下载',
		'toBeInstalled': '待安装',
		'installed': '已安装',
		'newApp': '新上架APP',
		'monthlyDownload': '月下载量',
		'topApp': '下载最多的APP',
		'downloads': '下载',
		'yes': '是',
		'no': '否',
		'ok': '好的',
		'commonTip': '点击搜索键发起搜索',
		//App
		'app': 'APP',
		'appSearch': "输入app名称搜索",
		'version': '版本号',
		'developer': '开发商',
    'company':'公司名称',
		'date': '日期',
    'LastDate': '上次上送日期',
		'size': '大小',
		'operation': '操作',
		'appBaic': 'APP基本信息页',
		'appParameterEdit': 'APP参数编辑页',
		'templateEdit': '终端参数模板编辑页',
		'apkFile': 'APK包',
		'icon': '图标',
		'packageName': '包名',
		'appName': 'APP名称',
		'intoduction': '介绍',
		'uninstall': '卸载',
		'enable': '启用',
		'disable': '禁用',
    'resourceFile':'资源文件',
    'UploadResource':'请上传资源文件',
		'appParameter': 'APP参数',
		'terminalParameterTemplate': '终端参数模板',
		'charTip50': '1-50个字符',
		'charTip200':　'1-200个字符',
		'uploadTipAPK': '请上传APK文件',
		'uploadTipXML': '请上传XML文件',
		'appCreateAsk': 'APP参数值已修改，是否建立下载任务?',
		'nextContact': '下次联机',
		'databaseName': '数据库字段名',
		'name': '名称',
		'value': '值',
    'defaultValue':'缺省值',
		'description': '备注',
		'fixedLength': '定长',
		'maxLength': '最大长度',
    'bulkEditMark': '批量修改',
		'versionExample': '比如 1.1.0',
		'deleteApp': '确认删除APP "',
    'deleteAppTop': '确认删除APP "',
    'deleteAppFoot':'" 吗? 相关的APP参数、终端参数、绑定终端的参数都将会一并删除',
		'enterContent': '请输入内容',
		'true': '是',
		'false': '否',
		'enter': '输入',
    'resourceNameSameCheck':'存在相同名称的资源文件，请先删除旧资源再进行上传',
    'appResourceFileMax':'该APP资源文件数量已达临界，无法继续添加',
    'resourceFileTaskCreateAsk': 'APP资源文件已修改，是否建立下载任务',
    'appUploadTime':'APP上传时间',
    'resourceUrl':'资源路径',

		//download
		'download': '下载',
		'createTaskMenu': '建立APP下载任务',
    'createTaskDeleteMenu':'建立APP删除任务',
		'downloadTasks': '下载任务列表',
		'createTask': '建立下载任务',
    'downloadDelete':'建立APP删除任务',
    'createDeleteTask':'建立删除任务',
    'DeleteTaskName':'删除任务名称',
    'deleteTime':'删除时间',
    'ImmediatelyDelete':'立即删除',
    'DeleteTime':'删除时段',
    'DeleteWarning':'删除提醒',
    'SilentUninstall':'静默删除',
    'askOperator':'询问操作员确认后删除',
		'appChoose': '已选',
		'downloadName': '下载任务名称',
		'downloadTime': '下载时间',
		'dateTime': '下载时段',
    'installTime1':'安装时段',
		'installTime': '安装时间',
		'installImmediately': '下载后立即安装',
		'installNotify': '安装提醒',
		'silentInstall': '静默安装',
		'askCashier': "询问收银员确认后安装",
		'pushRange': '发布范围',
		'allTerminal': '所有设备',
		'grayscale': '灰度范围发布',
		'downloadCreate': '请确定您需要建立下载任务 "',
    'createBack':'是否退出，如果您离开页面，将丢失当前内容？',
		'downloadTask': '下载任务',
		'type': '类型',
		'createDate': '时间',
		'total': '总设备数',
		'totals': '共计',
		'items': '项数据',
		'downSuccess': '下载成功',
		'downFail': '下载失败',
		'notStart': '未开始',
		'installSuccess': '安装成功',
		'installFail': '安装失败',
    'delSuccess': '删除成功',
    'delFail': '删除失败',
		'status': '状态',
		'inprogress': '进行中',
		'done': '结束',
		'cancelled': '终止',
		'appList': 'APP列表',
		'downloadCancel': '请确定您需要终止下载任务 "',
		'pleaseChoose': '请选择',
		'time': '时间',
		'appLists': 'APP列表',
    'appResourceFile':'APP资源文件下载',
    'downloading':'下载中',

    // 删除任务
    'forceUninstall': '强制卸载',

		//merchant
		'merchant': '商户',
		'merchantManage': '商户管理',
		'merchantInformation': '商户信息',
		'groupManage': '组管理',
		'merchantName': '商户名称',
		'contactName': '联系人姓名',
		'country': '国家/地区',
		'state': '省份',
		'district': '城区',
		'address': '地址',
		'merchantTip': '输入商户名称发起搜索',
		'phoneNo': '手机',
		'email': '邮箱',
		'companyName': '公司名称',
    'companies':'公司名称',
		'city': '城市',
		'postcode': '邮编',
		'Email': '邮箱',
		'telephoneNo': '电话',
		'groupName': '组名',
		'terminals': '设备数',
		'groupTip': '输入组名来搜索',
		'addTerminals': '新增设备',
		'searchKeyword': '搜索关键字',
		'selectArea': '选择区域',
		'sn': 'SN',
		'province': '省份',
		'area': '区域',
		'totalOf': '共',
		'equipmentInquire': '设备查询',
		'deleteGroup': '确定你要删除组 "',
		'deleteMerchant': '确定你要删除商户 "',
		'deleteUser': '确定你要删除用户 "',
    'functionManage':'功能设置管理',
    'function':'功能配置',
    'functionType':'功能类型',
    'functionAdd':'功能配置新增',
    'functionEdit':'功能配置编辑',
    'functionConfigurationManagement':'功能配置管理',
    'groupNameCheck':'请选择组名',
    'functionConfigCheck':'请选择功能',
    'deleteGroupFunction':'确定你要删除组:"',
    'landlineNumber':'座机号',
    'areaCode':'区号',
    'areaCodeCheck':'请输入正确的电话区号',
    'areaTypeCheck':'区号格式有误',
		//terminal
    'export':'导出',
    'paramExport':'参数导出',
		'terminal': '终端',
		'map': '地图',
    'model': '型号',
		'terminalParam': '终端参数',
		'appParam': 'App参数',
		'appDownload': 'App下载',
    'appDelete':'App删除',
		'copy': '复制',
		'copyTerminal': '复制终端',
		'copyNote': '注意：复制终端功能可以复制所选设备的所有APP信息、终端参数信息、商户归属、组归属等信息，输入新终端的SN号，完成复制。',
		'group': '组',
		'terminalLists': '终端参数列表',
		'valueEdit': '参数值（可编辑）',
		'item': '项目',
		'terminalCreateTask': '参数已更改，是否建立下载任务？',
		'deleteTerminal': '请确定您要删除此终端 SN:"',
		'addTerminal': '新增单台设备',
		'terminalEdit': '终端详情',
		'totalTerminals': '终端总数',
    'chooseAppPage':'App 选择页',
    'plsAddingAPP':'请选择需要添加的APP',
    'tickAPP': '请勾选App',
    'terminalParameterEmpty':'存在App的终端参数为空',
    'terminalCountLabelTail':'台终端',
    'terminalChoosed':'台选中',
    'activeReportTime':'最后联机时间',
    'alertStatus': "预警状态",
    'pn':'PN',
    'createTaskTipsStart':'下载任务将包含所有安装',
    'createTaskTipsEnd':'的终端.',
    'createDelTaskTipsEnd':'的终端.',

    // 终端编辑 - 位置服务
    'movingWarn': "移机预警",
    'movingTrack': '移动轨迹',
    'openMovingTrackMsg': '是否要开启位置上报服务，开启服务后将产数流量',
    'movingTrackSwitch': '移机轨迹开关',
    'locationService': "位置服务",
    'locationInfo':"位置信息",
    'locationServiceConfig':'配置',
    'relocationAlert': '移机警报开关',
    'movingDistance': '移动距离阈值',
    'locationUploadInterval': '位置上报频率',
    'locationUploadCreateTaskMsg': '终端位置相关配置已修改，即将创建下载任务，下载完成后配置生效。',
    'locationUploadIntervalError': '位置上报频率不能小于5分钟',
    'lastReportTime':'最后上报时间',
    'locationUploadAlert1': '客户端需要在V1.7.0版本以上',
    'locationUploadAlert2': '该服务未开通',
    'movingEffectiveTime': '生效时间',
    'trajectoryMessage':'该时间段内，没有相关位置信息',
    'selectedLocation': '选择位置',
    'selectedLocationTip1': '使用地图上的红点位置',
    'selectedLocationTip2': '使用先前保存的位置',
    'selectedLocationTip3': '使用地图上的蓝点位置',
    'selectStartingPoint': '选择起点',
    'optCurrentLocation': '当前位置',
    'optSelectLocation': '选择的位置',
    'optSelectNewLocation': '选择新位置',

		//diagnostic
		'diagnostic': '远程诊断',
		'rom': 'ROM版本号',
		'k21': '安全驱动程序版本',
		'currentInstall': '已安装的APP',
		'diagnosticData': '诊断数据',
		'paramName': '参数名称',
		'imei': 'IMEI',
		'meid': 'MEID',
		'memoryTotal': '内存总容量',
		'memoryAvailable': '内存可用容量 ',
		'flashTotal': 'FLASH总容量',
		'flashAvailable':'FLASH可用容量',
		'mobileDataFlow':'移动数据总流量',
		'turnOnOffTimes':'开关机次数',
		'turnOnTime':' 当前开机时间',
		'turnOnTimeSummary':'累计开机时间',
		'printerLength':' 打印机走纸总长度',
		'cardTimes':'刷卡次数 ',
		'icCardTimes':'IC卡插卡次数',
		'untouchCardTimes':'非接读卡次数 ',
		'frontCameraOpenTimes':' 前置摄像头开启次数',
		'backCameraOpenTimes':'后置摄像头开启次数',
		'batteryTemperature':'电池温度',
		'battery':' 电量',
		'batteryChargeTimes':' 充电次数',
    'androidVersion':'安卓版本',
    'spSystemVersion':'安全芯片系统版本',
    'spProtocolVersion':'安全芯片协议（应用）版本',
    'mainBoardBatteryVoltage':'主板电池电压',
    'wifiMacAddress':'WIFI MAC地址',
    'wifiIpAddress':'WIFI IP地址',
    'lanMacAddress':'以太网MAC地址',
    'lanIpAddress':'以太网IP地址',
    'mobileIpAddress':'移动网络IP',
    'language':'语言',
    'mobileNetworkType':'移动网络类型',
    'mobileNetworkSignal':'移动网络信号强度',
    'mobileMonthlyDataFlow':'当月移动数据流量',
    'k21Version':'安全驱动程序版本',
    'romVersion':'ROM 版本',
    'mobileNumber': '手机号',
    'networkOperatorName': '运营商名称',
    'location':'位置',

		//alert
		'alert': '警报',
		'openAlert': '警报',
		'alertHistory': '历史警报',
		'level': '级别',
		'high': '高',
		'middle': '中',
		'close': '关闭',
		'closeAll': '关闭全部',
		'closedTip': '关闭成功!',
    'moveAlertCloseInfo': '该终端的移机警报配置是否需要关闭？',

		//user
		'users': '用户',
		'userTip': '输入用户名称发起搜索',
		'accountName': '用户名',
		'subordinate': '用户信息',
		'basicInfo': '基本信息',
		'firstName': '姓氏',
		'lastName': '名字',
		'reconfirm': '再次确认',
		'selectAll': '全选',
		'merchantManagement': '商户管理',
		'appManagement': 'APP管理',
		'terminalManagement': '终端管理',
		'downloadManagement': 'App下载任务管理',
		'diagnosticManagement': '诊断管理',
		'alertManagement': '警报管理',
		'userManagement': '用户管理',
		'merchantQuery': '商户查询',
		'appQuery': 'APP查询',
		'terminalQuery': '终端查询',
		'downloadQuery': 'APP下载任务查询',
		'alertQuery': '警报查询',
    'reportCreate':'报表生成',
    'reportDownload':'报表下载',
		'permission':'权限设置',
    'systemManage':'系统管理',
		//tip
		'loginSuccess': '登录成功!',
		'logout': '退出登录成功!',
		'saveSuccess': '保存成功!',
		'submitSuccess': '提交成功!',
		'modifySuccess': '修改成功!',
		'deleteSuccess': '删除成功!',
		'createSuccess': '提交成功!',
    'building':'生成中...',
		'uploadSuccess': '上传成功!',
		'cancelSuccess': '取消成功!',
		'closeSuccess': '关闭成功!',
		'addSuccess': '新增成功!',
		'inputCheck': '必填项不能为空!',
    'sameCheck': '新密码和旧密码重复',
    'validCheck':'无效密码',
    'fileCheck': '文件过大',
    'veryCheck': '验证码不能为空!',
    'userNameCheck':'用户名不能为空',
    'passWordCheck':'密码不能为空',
    'userNameLength':'用户名长度超出',
    'passWordLength':'密码长度超出',
		'passwordCheck': '两次输入密码不一致!',
    'resellerNameCheck':'没有选择运营商',
    /*'passwordChecked': '密码输入不正确',*/
		'emailCheck': '请输入正确的邮箱格式',
    'phoneCheck':'请输入正确的电话',
		'imgCheck': '请上传正确的图片格式',
		'xmlCheck': '请上传XML文件',
		'dateCheck': '下载日期或时间未填',
		'installDateCheck': '安装日期或时间未填',
    'validDownloadTimes': '下载结束时间不能小于下载开始时间',
    'invalidTime':'日期设置不正确',
		'chooseApp': '请至少选择一个APP',
		'chooseOneApp': '请选择APP',
		'forceDelete': '是否确定删除此APP？包含此APP的下载任务也会一并删除',
		'forceEdit': '确定要更新APK包吗？包含此APP的未完成下载任务会同时被删除。',
    'resourceType':'类型',
    'others':'其它',
    'resourceVersion': '版本',
    'file':'文件',
		'enterKeyword': '输入关键字查询',
		'enterSN': '输入SN号查询',
		'enterApp': "输入App名称查询",
		'enterAccount': '输入账号搜索',
		'parameter': '参数',
		'resetPassword': '重置密码',
		'reset': '重置',
    'resetSuccess': '重置成功',
		'accountEmail': '用户名(邮箱)',
		//2018-11-13
		'groupTerminal': '组的终端列表',
		'terminalList': '终端列表',
		'triggerTransfer': '触发移机',
		'tamperCode': '篡改码',
		'failureCode': '失败码',
    'initialCoordinate':'初始位置',
		'currentCoordinate': '本次位置',
		'moveDistance': '移动距离',
		'freeMemory': '空闲内存',
		'freeStorage': '空闲存储空间',
		'deviceId': '设备ID',
    //2019-07-02
    'sure': '确定',

    //2020-07-24
    'join': '添加',
    'pleaseTick':'请先进行勾选',
    'noTickTerminal': '没有勾选终端,是否全选',
    'taskId': '任务ID',

    //终端预警状态
    'normal': '正常',
    'terminalNoConnect': '未联机',
    'terminalLost': '失联超过7天',
    'appTaskFailure': 'App任务失败',
    'terminalMove': '移机预警',
    'tamper': 'TAMPER',
    'lowMemory': '内存/FLASH容量低',
    'printerAgeing': '打印机老化',
    'batteryAgeing': '电池老化',
    'otherError': '其他异常',

    //report
    'report':'报表',
    'createReport':'创建报表',
    'reportDetail':'报表详情',
    'TerminalList':'终端报表',
    'TerminalParameter':'终端参数报表',
    'TerminalReportDetail':'终端报表详情',
    'TerminalParameterDetail':'终端参数详情',
    'lat':'纬度',
    'lng':'经度',
    'createTime':'创建时间',
    'resellerName':'运营商',
    'timeZone':'时区',
    'reportName':'报表名称',
    'No':'序号',
    'create':'创建',
    'reportId':'报表ID',
    'creating':'创建中',
    'completed':'已完成',
    'selectAPP':'选择APP',
    'downloadTaskStatusReport':'下载任务状态报表',
    'relocationWarningReport':'移机警报报表',
    'searchDownloadTask':'请输入下载名称',
    'selectDownloadTask':'下载任务查询',
    'chooseDownloadTask':'未选择需要生成报表的下载任务',

	},
	...zhLocale
}

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js